window.FavListHelper = class {

    static list = {};

	static init() {
		const self = this;

		this.$dropdownTrigger = $('#favoriteDropdownTrigger');
		this.$dropdownContainer = $('#favoriteDropdownContainer');

		// Click bind al dropdown del listado de favoritos
		this.$dropdownTrigger.on('click', self.onDropdownOpen.bind(this));

		// Bind de los triggers
		$('body').on('click', '[data-trigger^="FavList."]', function(event){
			event.stopPropagation();
			const target = event.currentTarget;

			switch(target.dataset.trigger) {
				case 'FavList.listingEvent':
					self.listingEvent(target);
					break; 
				case 'FavList.menuEvent':
					self.menuEvent(target);
					break; 
				case 'FavList.pubEvent':
					self.pubEvent(target);
					break; 
			}
		});
	}

    static clear() {
        const self = this;
        self.list = {};
    }

    static insert(data) {
        const self = this;

        self.load();

        for( let item of data) {
            if(!self.list[item.list_type]) {
                self.list[item.list_type] = [];
            }
            self.list[item.list_type].push( item.pub_id );
        }
    }

    static get(list_type) {
        const self = this;

        self.load();
        
        return self.list[list_type] || [];
    }

    static save() {
        const self = this;
        if( self.list )
            window.localStorage.setItem( 'favList', JSON.stringify(self.list));
    }

    static load() {
        const self = this;
        try {
            self.list = JSON.parse(window.localStorage.getItem('favList') || '{}');
        } catch( error ) {
            self.list = {};
        }
        return self.list;
    }

    static checked(listName, pub_id) {
        const self = this;

        if(!self.list.length) {
            self.load();
        }
        
        return self.list[listName] && self.list[listName].indexOf(pub_id) != -1;
    }

    static async menuEvent(target) {
        const self = this;
		console.log('menuEvent');

        var row = target.closest('.dropdown-item');

        Ladda.create(target).start();

        if( await self.sendEvent(target, 'delete')) {
            target.dataset.list_status = (target.dataset.list_status) * -1 + 1; // toogle entre 0 y 1
        }
        Ladda.create(target).stop();

        row.classList.add('hide');

        setTimeout(function(){
           row.remove(); //removing parent element with its contains
        }, 300)

        // Borrar estrellita de listado de anuncios
        for(let item of document.querySelectorAll(`.info-tag.info-favorite[data-pub_id='${target.dataset.pub_id}']`)) {
            item.dataset.list_status = "0"
        }
    }

    static async listingEvent(target) {
        const self = this;
        
        Ladda.create(target).start();

        if( await self.sendEvent(target)) {
            target.dataset.list_status = (target.dataset.list_status) * -1 + 1; // toogle entre 0 y 1
        }

        Ladda.create(target).stop();
    }

    static async pubEvent(el) {
        const self = this;

        let list_type = el.dataset.list_type;

        if( el.dataset['require_login'] == "1" && !(NOW.session.user_id > 0) ) {
			await Library.load(['LoginComponent']);
			await new LoginComponent().init();
            return;
        }
        else {
            let total = el.querySelector('.list-total');
            let totalValue = 0;
            if( total ) {
                totalValue = parseInt(total.innerHTML);
            }

            Ladda.create(el).start();

            if( await self.sendEvent(el)) {          
                // Borrar
                if( el.dataset.list_status == 1) {
                    el.dataset.list_status = 0;
                    if( total && totalValue > 0 ) {
                        total.innerHTML = totalValue - 1;
                    }
                    if( list_type == 'like') {
                        document.getElementById('favDropdownIcon').classList.remove('font-weight-800');
                    }
                } 
                // Agregar
                else {
                    el.dataset.list_status = 1;
                    if(total)
                        total.innerHTML = totalValue + 1;
                    if( list_type == 'like') {
                        document.getElementById('favDropdownIcon').classList.add('font-weight-800');
                    }
                }
            }
            Ladda.create(el).stop();
            
        }
    }

    static listingOnChange(base = document) {
        const self = this;

        for(let item of base.querySelectorAll('.info-tag.info-favorite')) {
            if( self.checked('favorite', item.dataset.pub_id)) {
                item.dataset.list_status = "1";
            }
        }
    }

    static async sendEvent(el, action) {
        
        const self = this;
        try {

            let list_type = el.dataset.list_type;
            let pub_id = el.dataset.pub_id;
            let actionAdd = action? action == 'post' : el.dataset.list_status != 1;
                       
            if(NOW.session.user_id == pub_id) {
                return false;
            }

            // Guardar localmente
            self.load();

            if( actionAdd && el.dataset.list_type == 'favorite' ) {
                // hardcodeado -- todo : levantar del serrvidor
                if( self.list.favorite ) {
                    if(!(NOW.session.user_id > 0) && self.list.favorite.length >= 10 ) {
                        AlertUi.error(null, `<div class="px-10">Llegaste al límite de <label class='font-weight-800'>10 favoritos</label>! registrate para agregar más.</div>
                            <hr class="mt-10">
                            <button type="button" class='btn text-primary btn-xl w-full mb--20' data-trigger='Auth.register'>Registrarse</button>
                        `);
                        return false;
                    }
                    if(NOW.session.user_id > 0 && NOW.session.user_type == 'user' && self.list.favorite.length >= 20 ) {
                        AlertUi.error(null, "Llegaste al limite de 20 favoritos");
                        return false;
                    }
                }
            }

            let request = axios({
                method: actionAdd ? 'post' : 'delete',
                url: `/api/favlist/${list_type}/${pub_id}`,
                data: {
                    pub_id: pub_id,
                    list_type: list_type,
                }
            });

            // Si va a agregar el 1er favorito. Traer tutirual justo con el request de la accion
            if(list_type == 'favorite' && actionAdd == true && (!self.list[list_type] || self.list[list_type].length == 0)) { 
                let [res] = await Promise.all([
                    request,
                    PhrasesService.load(['FAVORITES_TUTORIAL_TITLE', 'FAVORITES_TUTORIAL_SUBTITLE']),
                ]);
            }
            else
            {
                // Sino solo realizar la accion.
                let res = await request;
            }
            
            if( !self.list[list_type] )
                self.list[list_type] = [];

            var index = self.list[list_type].indexOf(pub_id);
            if( actionAdd ) {
                if( index == -1 ) {
                    self.list[list_type].push(pub_id); // add
                }
            } else {
                if( index > -1 ) {
                    self.list[list_type].splice(index, 1); // delete
                }
            }

            if(list_type == 'favorite' && actionAdd == true && self.list[list_type].length == 1) {
                AlertUi.success(null, `
                    <div class="text-center">
                        <h3 class="mt-10">${PhrasesService.get('FAVORITES_TUTORIAL_TITLE')}</h3>
                        <div>${PhrasesService.get('FAVORITES_TUTORIAL_SUBTITLE')}</div>
                        <video disableRemotePlayback loop muted playsinline autoplay class="mt-10 w-full" src="${NOW.settings.url_static}/images/favorite-tutorial-1.mp4"></video>
                    </div>
                `);
            }
        
            self.save();

            return true;

        } catch(err) {
            console.log(err);
            AlertUi.confirm({
                'title': 'Oops',
                'msg':  err?.response?.data?.message || err,
                'type': 'OK',
            });
        }

        return false;
    }

	static async onDropdownOpen(event) {
		const self = this;

		// Si es false, el dropdown ya estaba abierto y se esta cerrando.
		if( !event.target.ariaExpanded ) {
			return;
		}

		// Mostrar loading...
		this.$dropdownContainer.html('<div class="text-center pb-20"><i class="fas fa-circle-notch fa-spin fa-2x" style="animation-duration: 1s; opacity: 0.5"></i></div>');

		//
		// const res = await axios.get('/api/favlist');

		// Realizar request. Si esta logueado no enviar las ids, se van a levantar directo en el server.
		if( NOW.session.user_id ) {
			var response = await fetch(`/api/public/favorites/`);
			response = await response.text();
			this.$dropdownContainer.html(response);
		} else if (FavListHelper.get('favorite').length) {
			var response = await fetch(`/api/public/favorites/${FavListHelper.get('favorite')}`);
			response = await response.text();
			this.$dropdownContainer.html(response);
		} else this.$dropdownContainer.html('');
	}
};